<template>
	<div class="GIS">
		<div class="head_nav"></div>
		<div class="button-box">
			<el-collapse v-model="activeName">
				<el-collapse-item accordion="true" title="显示类型" name="1">
					<div class="item-collapse">
						<p><i class="iconfont iconyonghu" :style="{color:colors[0]}" /><span>普通用户</span> </p>
						<span :class="peopleMarkerShow?'active-switch':'switch'" @click="showMarker('peopleMarkerShow')"></span>
					</div>
					<div class="item-collapse">
						<p><i class="iconfont iconqiakoushexiangtou" :style="{color:colors[1]}" /><span>摄像机</span> </p>
						<span :class="cameraMarkerShow?'active-switch':'switch'" @click="showMarker('cameraMarkerShow')"></span>
					</div>
					<div class="item-collapse">
						<p><i class="iconfont iconqiuzhu" :style="{color:colors[2]}" /><span>求助事件</span> </p>
						<span :class="helpAlarmMarkerShow?'active-switch':'switch'" @click="showMarker('helpAlarmMarkerShow')"></span>
					</div>
					<div class="item-collapse">
						<p><i class="iconfont iconbaojingshanshuo" :style="{color:colors[3]}" /><span>报警事件</span> </p>
						<span :class="alarmMarkerShow?'active-switch':'switch'" @click="showMarker('alarmMarkerShow')"></span>
					</div>
					<div class="item-collapse">
						<p><i class="iconfont iconweiwangguanicon-defuben-" :style="{color:colors[4]}" /><span>机顶盒</span> </p>
						<span :class="STBMarkerShow?'active-switch':'switch'" @click="showMarker('STBMarkerShow')"></span>
					</div>
					<div class="item-collapse">
						<p><i class="iconfont iconweiwangguanicon-defuben-" :style="{color:colors[5]}" /><span>指挥中心</span> </p>
						<span :class="controlMarkerShow?'active-switch':'switch'" @click="showMarker('controlMarkerShow')"></span>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="search-box">
			<input @keyup.enter="searchCamera()" v-model="cameraName" type="text" placeholder="请输入摄像机名称">
			<span @click="searchCamera()">搜索</span>
		</div>
		<div class="camera-btn-box" v-if="cameraDataList.length!=0&&cameraMarkerShow">
			<el-button type="primary" :disabled="cameraDataList.length==0" @click="choosedCamera" :class="isChoosedStatus?'camera-btn-active':'camera-btn'">框选摄像机播放</el-button>
		</div>
		<div class="right-box">
			<div class="total-box" style="font-size: 24px;position:relative;right: 20px;left: auto;" v-if="cameraMarkerShow && onlineRate">
				<span>在线率：{{onlineRate}}</span>
			</div>
			<div class="total-box" style="font-size: 24px;;position:relative;right: 20px;left: auto;" v-if="STBMarkerShow">
				<span>机顶盒数量</span>
				<span>{{STBStatistics}}</span>
			</div>
			<div class="total-box" style="font-size: 24px;;position:relative;right: 20px;left: auto;" v-if="cameraMarkerShow">
				<span>摄像头数量</span>
				<span>{{cameraStatistics}}</span>
			</div>
		</div>

		<div id="map-container" style="height: 100%;width: 100%;"></div>

		<!-- 接警中心人员列表 -->
		<div class="user-list" v-if="showControlUserList">
			<div class="user-head">{{chosedControl}}接警中心</div>
			<div v-if="controlUserList.length!=0">
				<div class="user-item" v-for="(item,index) in controlUserList" :key="index">
					<div class="user-img">
						<img :src="item.portrait" alt="">
					</div>
					<div class="user-control-detail">
						<span class="name">{{item.realName}}</span>
						<span class="phone">{{item.phone}}</span>
						<span class="actvie-btn" v-if="item.online" @click="vision(item.id)">可视对讲</span>
						<span class="btn" v-else>可视对讲</span>
					</div>
				</div>
			</div>
			<div class="null-user" v-else>
				{{暂无相关人员}}
			</div>
		</div>
	</div>
</template>

<script>
	import AMap from 'AMap'
	import {
		GISApi
	} from '../../api-path/timeGis-api.js'
	import {
		websock
	} from '../../assets/js/socket'
	import publicAPI from '../../api-path/public-api.js'
	import moment from 'moment'
	export default {
		name: "GIS",
		data() {
			return {
				date: '', // 当前日期
				map: {}, // 地图实列
				websock: websock,
				IntarvalRate: '',
				onlineRate: '', // 在线率
				cameraStatistics: 0, //摄像头统计
				STBStatistics: 0, // 机顶盒统计
				ALARMStatistics: 0, // 报警柱统计
				longitude: '104.06',
				latitude: '30.67',

				activeName: '1', // 默认展开按钮面板
				peopleMarkerShow: false, // 是否显示人员 标注
				cameraMarkerShow: true, // 是否显示摄像机 标注
				helpAlarmMarkerShow: false, // 是否显示 求助事件 标注
				alarmMarkerShow: false, // 是否显示 报警事件 标注
				STBMarkerShow: false, // 是否显示 机顶盒 标注
				controlMarkerShow: true, //是否显示 指挥中心 标注

				currentZoomLevel: 8, // 当前地图缩放等级
				pic: 3, // 网格聚合的等级
				limitedNum: 100, // 网格聚合数
				distance: 1, // 查询的范围
				cameraName: '', // 摄像机名称
				areaId: '0', // 区域code
				zoom: 8, // 地图缩放层级
				zooms: [5, 18], //地图缩放层级限制
				center: [], // 地图中心点

				markersArrayEvent: [], // 事件maker（聚合）
				markerEventDataArray: [], // 事件数据（聚合）

				markersArrayCamera: [], // 摄像机maker（聚合）
				markerCameraDataArray: [], // 摄像机数据（聚合）

				markersArrayHelp: [], // 求助maker（聚合）
				markerHelpDataArray: [], // 求助数据（聚合）

				markersArraySTB: [], // 机顶盒（聚合）
				markerSTBDataArray: [], // 机顶盒数据(聚合)

				markersArrayUser: [], // 用户maker（聚合）
				markerUserDataArray: [], // 用户数据（聚合）

				markersArrayControl: [], // 指挥中心maker（聚合）
				markerControlDataArray: [], // 指挥中心数据（聚合）

				markerEventArrayPosition: [], // 事件坐标maker集合
				markersEvent: [], // 事件maker
				EventtData: [], // 事件数据

				markerCameraArrayPosition: [], // 摄像机坐标maker集合
				markersCamera: [], // 摄像机maker
				cameraData: [], // 摄像机数据

				markerHelpArrayPosition: [], // 求助坐标maker集合
				markersHelp: [], // 求助maker
				HelpData: [], // 求助数据

				markerSTBArrayPosition: [], //  机顶盒坐标maker集合
				markersSTB: [], // 机顶盒maker
				STBData: [], // 机顶盒数据

				markerUserArrayPosition: [], // 用户坐标maker集合
				markersUser: [], // 用户maker
				userData: [], // 用户数据

				markerControlArrayPosition: [], // 指挥中心坐标maker集合
				markersControl: [], // 指挥中心maker
				controlData: [], // 指挥中心数据

				eventTooptip: {}, // 事件tooltip
				cameraTooltip: {}, // 摄像机tooltip
				HelpTooltip: {}, // 求助tooltip
				StbTooptip: {}, // 机顶盒tooltip
				userTooptip: {}, // 用户tooltip
				controlTooptip: {}, // 指挥中心tooltip

				polyline: '', // 用户轨迹
				count: 0, // 聚合数量
				markerTimeOut: '', // 延时查询

				colors: ['#0ce8ef', '#bc50fb', '#db7905', '#ff3738', '#ddc822', '#0ce8ef'],

				controlUserList: [], //指挥中心人员列表
				showControlUserList: false,
				chosedControl: '',

				//框选摄像机播放
				isChoosedStatus: false, //是否框选摄像机状态
				cameraDataList: [], //marker摄像机列表
				mouseTool: '', //框选工具
				choosedTool: '', //框选信息
			}
		},
		created() {
			let _this = this
			this.getDate() //获取当前年月
			this.getStatistics() //获取统计
			// this.IntarvalRate = setInterval(function() {
			// 	// _this.getUser()//获取在线率
			// }, 60 * 1000 * 5)
		},
		mounted() {
			this.initMap() // 初始化地图
			//this.initSocket()
		},
		beforeDestroy() {
			// this.websock.onclose()
			// clearInterval(this.IntarvalRate)
		},
		methods: {
			/*-------------------------初始化地图-----------------------*/
			initMap() {
				let $this = this;
				$this.map = new AMap.Map('map-container', {
					resizeEnable: true,
					zoom: $this.zoom,
					viewMode: '2D',
					mapStyle: 'amap://styles/bc799cd851b4315c60b7a8e2d6e71696',
					zooms: $this.zooms
				})
				$this.getareaId() // 查询当前地图中心点的区域code
				// 框选
				AMap.plugin(["AMap.MouseTool"], function() {
					$this.mouseTool = new AMap.MouseTool($this.map);
				});
				// 缩放
				$this.map.on('zoomend', $this.getZoom);
				$this.moveOn() // 绑定移动事件
				$this.getDataAll() // 获取所有聚合数据
			},
			/*-------------------------缩放--------------------------*/
			// 地图缩放
			getZoom() {
				if (this.polyline) {
					return false
				}
				let zoom = this.map.getZoom(); //获取当前地图级别
				clearTimeout(this.markerTimeOut) // 清除缩放事件
				this.moveOff() // 解除移动事件
				/*清除所有标记*/
				this.claearOther()
				this.clearMapMaker() //清除标记
				this.clearMarkerData() //清除标记数据
				this.clearMapPloy() //  清除地图聚合
				this.clearPloyData() // 清除聚合数据

				this.setPic(zoom) // 设置查询层级

				this.zoom = zoom // 保存当前地图缩放层级

				this.zoomFn() // 查询数据

				this.getareaId() // 查询当前地图中心点的区域code

				this.center = this.map.getCenter()
			},

			// 查询数据
			zoomFn() {
				let that = this
				that.markerTimeOut = setTimeout(function() {
					that.moveOn()
					that.getDataAll()
				}, 500)
			},

			// 获取区域code
			getareaId() {
				const url = `${GISApi.gdMapView}?location=${this.map.getCenter()}&radius=1000`
				this.$http.get(url).then(res => {
					if (res.status === 200) {
						this.setareaId(res.result)
						this.getDataAll()
					}
				})
			},

			// 设置区域code
			setareaId(res) {
				const zoom = this.zoom
				if (zoom <= 9) {
					this.areaId = res.regeocode.addressComponent.towncode.slice(0, 2)
					return
				}

				if (zoom <= 11) {
					this.areaId = res.regeocode.addressComponent.towncode.slice(0, 4)
					return
				}

				if (zoom <= 13) {
					this.areaId = res.regeocode.addressComponent.towncode.slice(0, 6)
					return
				}

				if (zoom > 13) {
					this.areaId = res.regeocode.addressComponent.towncode.slice(0, 9)
					return
				}
			},

			// 设置查询登记
			setPic(zoom) {

				if (zoom <= 9) {
					this.pic = 3;
					return
				}

				if (zoom <= 11) {
					this.pic = 4;
					return
				}

				if (zoom <= 13) {
					this.pic = 5;
					return
				}

				if (zoom > 13) {
					this.pic = 8;
					return
				}
			},

			/*-------------------------查询（摄像机）-------------------------*/
			searchCamera() {
				if (!this.cameraMarkerShow) {
					return false
				}
				this.map.remove(this.markersArrayCamera); // 摄像机聚合
				this.map.remove(this.markersCamera); // 摄像机
				this.map.remove(this.cameraTooltip); // 清除摄像头信息框

				this.cameraData = [] // 摄像头
				this.markersCamera = [] // 摄像头marker
				this.markerCameraArrayPosition = [] // 摄像头经纬度
				this.markerCameraDataArray = []; // 摄像机数据（聚合）
				this.markersArrayCamera = []; // 摄像机maker（聚合）

				this.getCameraData()
			},
			/*-------------------------移动-------------------------*/
			// 移动结束
			mapMoveend() {
				if (this.polyline) {
					return false
				}
				let that = this

				this.clearMapPloy() //  清除地图聚合
				this.clearPloyData() // 清除聚合数据
				this.claearOther() //清除其他

				setTimeout(() => {
					if (this.cameraName) {
						this.cameraList()
					} else {
						this.getareaId()
					}

					that.getDataAll()

				}, 500)
			},

			// 绑定移动事件
			moveOn() {
				this.map.on('movestart', this.mapMovestart);
				this.map.on('mapmove', this.mapMove);
				this.map.on('moveend', this.mapMoveend);
			},
			// 解除移动事件
			moveOff() {
				this.map.off('movestart', this.mapMovestart);
				this.map.off('mapmove', this.mapMove);
				this.map.off('moveend', this.mapMoveend);
			},

			/*----------------------------聚合--------------------------------------*/
			// 获取聚合数据
			getDataAll() {
				if (this.peopleMarkerShow) {
					this.getUserDataEvent() // 人员聚合
				}
				if (this.cameraMarkerShow) {
					this.getCameraData() // 摄像机聚合
				}
				if (this.STBMarkerShow) {
					this.getSTBData() // 机顶盒聚合
				}
				if (this.alarmMarkerShow) {
					this.getEventData() //事件聚合
				}
				if (this.helpAlarmMarkerShow) {
					this.helpEventList() //求助聚合
				}

				if (this.controlMarkerShow) {
					this.getControlData() //求助聚合
				}
			},
			// 网格聚合（用户）
			getUserDataEvent() {
				// let zoom = this.map.getZoom(); //获取当前地图级别
				let bounds = this.map.getBounds();
				let params = {
					areaId: this.areaId,
					limitedNum: this.limitedNum,
					zoom: this.map.getZoom(),
					type: ''
				}
				// if (zoom >= 14) {
				params.bottomLat = bounds.southwest.lat, // 底部的纬度
					params.lonLeft = bounds.southwest.lng, // 左经度
					params.lonRight = bounds.northeast.lng, //右经度
					params.topLat = bounds.northeast.lat, // 最高纬度
					params.limitedNum = this.limitedNum
				// }
				this.$http.get(GISApi.user, {
					params
				}).then(res => {
					if (res.status === 200 && this.peopleMarkerShow) {
						if (res.result && res.result.data.length > 0) {
							if (res.result.zoom !== this.map.getZoom()) {
								return false
							}
							if (res.result.aggType) {
								this.initData(res.result.data, 'userData', 'user')
							} else {
								this.markersArrayUser = [...this.markersArrayUser, ...res.result.data];
								this.markersArrayUser.map(item => {
									if (item.longitude && item.latitude) {
										let data = {
											position: [item.longitude?item.longitude:0, item.latitude?item.latitude:0],
											count: item.num,
											name: item.name,
											areaId: item.areaId
										}
										this.markersType(data, 'markersArrayUser', 'markersDom')
									}
								})
							}
						}
					}
				})

			},
			// (网格聚合)求助
			helpEventList() {
				// let zoom = this.map.getZoom(); //获取当前地图级别
				let bounds = this.map.getBounds();
				let params = {
					areaId: this.areaId,
					limitedNum: this.limitedNum,
					zoom: this.map.getZoom(),
					type: ''
				}
				// if (zoom >= 14) {
				params.bottomLat = bounds.southwest.lat, // 底部的纬度
					params.lonLeft = bounds.southwest.lng, // 左经度
					params.lonRight = bounds.northeast.lng, //右经度
					params.topLat = bounds.northeast.lat, // 最高纬度
					params.limitedNum = this.limitedNum
				// }
				this.$http.get(GISApi.neighborhood, {
					params
				}).then(res => {
					if (res.status === 200 && this.helpAlarmMarkerShow) {
						if (res.result && res.result.data.length > 0) {
							if (res.result.zoom !== this.map.getZoom()) {
								return false
							}
							if (res.result.aggType) {
								this.initData(res.result.data, 'HelpData', 'help')
							} else {
								this.markersArrayHelp = [...this.markersArrayHelp, ...res.result.data];
								this.markersArrayHelp.map(item => {
									if (item.longitude && item.latitude) {
										let data = {
											position: [item.longitude?item.longitude:0, item.latitude?item.latitude:0],
											count: item.num,
											name: item.name,
											areaId: item.areaId
										}
										this.markersType(data, 'markersArrayHelp', 'markersDom')
									}
								})
							}
						}
					}
				})
			},
			// 网格聚合（摄像机）
			getCameraData() {
				let zoom = this.map.getZoom(); //获取当前地图级别
				let bounds = this.map.getBounds();
				let params = {
					areaId: this.areaId,
					limitedNum: this.limitedNum,
					keyWord: this.cameraName,
					distance: '',
					type: '',
					zoom: zoom,
				}
				// if (zoom >=12 ) {
				params.bottomLat = bounds.southwest.lat; // 底部的纬度
				params.lonLeft = bounds.southwest.lng; // 左经度
				params.lonRight = bounds.northeast.lng; //右经度
				params.topLat = bounds.northeast.lat; // 最高纬度
				// }
				this.$http.get(GISApi.camera, {
					params
				}).then(res => {
					if (res.status === 200 && this.cameraMarkerShow) {
						if (res.result.zoom !== this.map.getZoom()) {
							return false
						}
						if (res.result && res.result.data.length > 0) {
							if (res.result.aggType) { //散点
								this.initData(res.result.data, 'cameraData', 'camera')
								this.cameraDataList = res.result.data;
							} else { // 聚合
								this.cameraDataList = [];
								this.markerCameraDataArray = [...this.markerCameraDataArray, ...res.result.data];
								this.markerCameraDataArray.map(item => {
									if (item.longitude && item.latitude) {
										let data = {
											position: [item.longitude?item.longitude:0, item.latitude?item.latitude:0],
											count: item.num,
											name: item.name,
											areaId: item.areaId
										}
										this.markersType(data, 'markersArrayCamera', 'markersDom')
									}
								})
							}
						}
					}
				})
			},
			// 网格聚合（事件）
			getEventData() {
				let zoom = this.map.getZoom(); //获取当前地图级别
				let bounds = this.map.getBounds();
				let params = {
					areaId: this.areaId,
					limitedNum: this.limitedNum,
					zoom: zoom,
					type: ''
				}
				// if (zoom >= 14) {
				params.bottomLat = bounds.southwest.lat; // 底部的纬度
				params.lonLeft = bounds.southwest.lng; // 左经度
				params.lonRight = bounds.northeast.lng; //右经度
				params.topLat = bounds.northeast.lat; // 最高纬度
				// }
				this.$http.get(GISApi.alarmOwn, {
					params
				}).then(res => {
					if (res.status === 200 && this.alarmMarkerShow) {
						if (res.result && res.result.data && res.result.data.length > 0) {
							if (res.result.zoom !== this.map.getZoom()) {
								return false
							}
							if (res.result.aggType) { //散点
								this.initData(res.result.data, 'EventtData', 'event')
							} else { //聚合
								this.markersArrayHelp = [...this.markersArrayHelp, ...res.result.data];
								this.markersArrayHelp.map(item => {
									if (item.longitude && item.latitude) {
										let data = {
											position: [item.longitude?item.longitude:0, item.latitude?item.latitude:0],
											count: item.num,
											name: item.name,
											areaId: item.areaId
										}
										this.markersType(data, 'markersArrayEvent', 'markersDom')
									}
								})
							}
						}
					}
				})
			},
			// 网格聚合（机顶盒）
			getSTBData() {
				let zoom = this.map.getZoom(); //获取当前地图级别
				let bounds = this.map.getBounds();
				let params = {
					areaId: this.areaId,
					limitedNum: this.limitedNum,
					zoom: zoom,
					type: '0'
				}
				// if (zoom > 13) {
				params.bottomLat = bounds.southwest.lat; // 底部的纬度
				params.lonLeft = bounds.southwest.lng; // 左经度
				params.lonRight = bounds.northeast.lng; //右经度
				params.topLat = bounds.northeast.lat; // 最高纬度
				// }
				this.$http.get(GISApi.stbMashup, {
					params
				}).then(res => {
					if (res.status === 200 && this.STBMarkerShow) {
						if (res.result && res.result.data.length > 0) {
							if (res.result.zoom !== this.map.getZoom()) {
								return false
							}
							if (res.result.aggType) { //散点
								this.initData(res.result.data, 'STBData', 'STB')
							} else { //聚合
								this.markersArraySTB = [...this.markersArraySTB, ...res.result.data];
								this.markersArraySTB.map(item => {
									if (item.longitude && item.latitude) {
										let data = {
											position: [item.longitude?item.longitude:0, item.latitude?item.latitude:0],
											count: item.num,
											name: item.name,
											areaId: item.areaId
										}
										this.markersType(data, 'markersArraySTB', 'markersDom')
									}
								})
							}
						}
					}
				})

			},
			// 网格聚合 (指挥中心)
			getControlData() {
				let zoom = this.map.getZoom(); //获取当前地图级别
				let bounds = this.map.getBounds();
				let params = {
					areaId: this.areaId == 0 ? '' : this.areaId,
					limitedNum: this.limitedNum,
					type: '',
					zoom: zoom,
				}
				// if (zoom >=12 ) {
				params.bottomLat = bounds.southwest.lat; // 底部的纬度
				params.lonLeft = bounds.southwest.lng; // 左经度
				params.lonRight = bounds.northeast.lng; //右经度
				params.topLat = bounds.northeast.lat; // 最高纬度
				// }
				this.$http.get(GISApi.controlCenter, {
					params
				}).then(res => {
					if (res.status === 200 && this.controlMarkerShow) {
						if (res.result.zoom !== this.map.getZoom()) {
							return false
						}
						if (res.result && res.result.data.length > 0) {
							// if (res.result.aggType) {//散点
							this.initData(res.result.data, 'controlData', 'control')
							// } else { // 聚合
							// 	this.markerControlDataArray = [...this.markerControlDataArray, ...res.result.data];
							// 	this.markerControlDataArray.map(item => {
							// 		if (item.longitude && item.latitude) {
							// 			let data = {
							// 				position: [item.longitude, item.latitude],
							// 				count: item.num,
							// 				name: item.name,
							// 				areaId: item.areaId
							// 			}
							// 			this.markersType(data, 'markersArrayControl', 'markersDom')
							// 		}
							// 	})
							// }
						}
					}
				})
			},


			// 处理数据
			initData(resData, dataName, type) {
				let bounds = this.map.getBounds();
				const bottomlat = bounds.southwest.lat; // 底部的纬度
				const lngleft = bounds.southwest.lng; // 左经度
				const lngright = bounds.northeast.lng; //右经度
				const toplat = bounds.northeast.lat; // 最高纬度
				let data = []
				let markerData = []

				this[dataName] = [...this[dataName], ...resData]; // 合并数据

				this[dataName].forEach(item => {
					markerData.push(JSON.stringify(item)) // 将数据转换为字符串（去重用）
					if (lngright > item.longitude && item.longitude > lngleft && toplat > item.latitude && item.latitude > bottomlat) { // 筛选屏幕内的数据
						data.push(JSON.stringify(item))
					}
				})

				data = [...new Set(data)] // 用于显示marker的数据去重
				markerData = [...new Set(markerData)] // 数据去重

				this[dataName] = markerData.map(item => {
					return JSON.parse(item) // 去重后 重新赋值数据
				})

				data = data.map(item => {
					return JSON.parse(item) // 去重后 重新赋值显示marker的数据
				})

				data.map(item => {
					if (type === 'camera') {
						let data = {
							position: [item.longitude, item.latitude],
							aucCameraId: item.aucCameraId,
							id: item.id,
							onlineType: item.onlineType
						}
						if (!this.markerCameraArrayPosition.includes(JSON.stringify(data.position))) { // 判断当前摄像头在
							this.markersType(data, 'markersCamera', 'markerCameraDom')
							this.markerCameraArrayPosition.push(JSON.stringify(data.position))
						}
					}

					if (type === 'user') {
						let markerData = {
							position: [item.longitude, item.latitude],
							aucCameraId: item.aucCameraId,
							id: item.id,
							name: item.name,
							address: item.address,
							onlineType: item.onlineType
						}
						if (!this.markerUserArrayPosition.includes(JSON.stringify(markerData.position))) { //
							this.markersType(markerData, 'markersUser', 'markerUserDom')
							this.markerUserArrayPosition.push(JSON.stringify(data.position))
						}
					}

					if (type === 'help') {
						let markerData = {
							position: [item.longitude, item.latitude],
							realName: item.realName,
							phone: item.phone,
							address: item.address,
							createGmt: item.createGmt,
							content: item.content,
							id: item.id,
						}
						if (!this.markerHelpArrayPosition.includes(JSON.stringify(markerData.position))) { // 判断当前摄像头在
							this.markersType(markerData, 'markersHelp', 'markerEventDom')
							this.markerHelpArrayPosition.push(JSON.stringify(data.position))
						}
					}

					if (type === 'event') {
						let markerData = {
							position: [item.longitude, item.latitude],
							address: item.address,
							name: item.name,
							terminalCode: item.terminalCode,
							id: item.id,
							centerName: item.centerName,
							happenDate: item.happenDate
						}
						if (!this.markerEventArrayPosition.includes(JSON.stringify(markerData.position))) { // 判断当前摄像头在
							this.markersType(markerData, 'markersEvent', 'markerEventDom')
							this.markerEventArrayPosition.push(JSON.stringify(data.position))
						}
					}
					if (type === 'STB') {
						let markerData = {
							position: [item.longitude, item.latitude],
							address: item.address,
							name: item.name,
							terminalCode: item.terminalCode,
							id: item.id,
						}
						if (!this.markerSTBArrayPosition.includes(JSON.stringify(markerData.position))) { // 判断当前摄像头在
							this.markersType(markerData, 'markersSTB', 'markerSTBDom')
							this.markerSTBArrayPosition.push(JSON.stringify(data.position))
						}
					}

					if (type === 'control') {
						let markerData = {
							position: [item.longitude, item.latitude],
							address: item.address,
							name: item.name,
							terminalCode: item.terminalCode,
							id: item.id,
						}
						if (!this.markerSTBArrayPosition.includes(JSON.stringify(markerData.position))) { // 判断当前摄像头在
							this.markersType(markerData, 'markersControl', 'markerControlDom')
							this.markerControlArrayPosition.push(JSON.stringify(data.position))
						}
					}

				})
			},
			/*-----------------------------详情----------------------------------------*/
			// 获取事件详情
			getEventInfo(markerObj, AMarker) {
				this.eventTooptip = new AMap.InfoWindow({
					isCustom: true,
					closeWhenClickMap: true,
					position: markerObj.position,
					content: this.eventTooltip(markerObj),
					offset: new AMap.Pixel(0, -20)
				})
				this.eventTooptip.open(this.map)

				AMarker.on('mouseout', () => {
					this.map.remove(this.eventTooptip);
				})
			},
			// 获取求助事件详情
			getHelpEventInfo(markerObj, AMarker) {
				this.eventTooptip = new AMap.InfoWindow({
					isCustom: true,
					closeWhenClickMap: true,
					position: markerObj.position,
					content: this.helpTooltip(markerObj),
					offset: new AMap.Pixel(0, -20)
				})
				this.eventTooptip.open(this.map)

				AMarker.on('mouseout', () => {
					this.map.remove(this.helpTooltip);
				})
			},

			// 获取机顶盒详情
			getJBInfo(markerObj, AMarker) {
				this.StbTooptip = new AMap.InfoWindow({
					isCustom: true,
					closeWhenClickMap: true,
					position: markerObj.position,
					content: this.JBTooltip(markerObj),
					offset: new AMap.Pixel(0, -20)
				});
				this.StbTooptip.open(this.map);
				AMarker.on('mouseout', () => {
					this.map.remove(this.StbTooptip)
				});
			},
			// 摄像机详情
			getCameraInfo(markerObj, AMarker) {
				this.$http.get(GISApi.getStatistics, {
					params: {
						id: markerObj.id
					}
				}).then(res => {
					if (res.status === 200) {
						let data = res.result
						this.cameraTooltip = new AMap.InfoWindow({
							isCustom: true,
							closeWhenClickMap: true,
							position: markerObj.position,
							content: this.createCameraTooltip(data),
							offset: new AMap.Pixel(0, -20)
						})
						this.cameraTooltip.open(this.map)
						AMarker.on('mouseout', () => {
							this.map.remove(this.cameraTooltip);
						})
					}
				})
			},
			//用户详情
			getUserInfo(markerObj, AMarker) {
				this.userTooltip = new AMap.InfoWindow({
					isCustom: true,
					closeWhenClickMap: true,
					position: markerObj.position,
					content: this.userToolMtip(markerObj),
					offset: new AMap.Pixel(0, -20)
				})
				this.userTooltip.open(this.map)

				AMarker.on('mouseout', () => {
					this.map.remove(this.userTooptip);
				})
			},
			/*---------------------------marker-----------------------------------------*/
			// 区分markers 类型
			markersType(data, markersName, fnName) {
				let markerObj = {
					position: data.position,
					markersName: markersName,
					id: data.id || '',
					aucCameraId: data.aucCameraId || '',
					center: []
				};
				// 事件聚合
				if (markersName === 'markersArrayEvent') {
					markerObj.fn = this[fnName](data.count, 'rgb(255, 55, 56)', data.name)
				}
				// 用户聚合
				if (markersName === 'markersArrayUser') {
					markerObj.fn = this[fnName](data.count, 'rgb(12, 232, 239)', data.name)
				}
				// 求助聚合
				if (markersName === 'markersArrayHelp') {
					markerObj.areaId = data.areaId
					markerObj.fn = this[fnName](data.count, 'rgb(219, 121, 5)', data.name)
				}
				// 摄像机聚合
				if (markersName === 'markersArrayCamera') {
					markerObj.areaId = data.areaId
					markerObj.fn = this[fnName](data.count, 'rgb(188, 80, 251)', data.name)
				}

				// 机顶盒聚合
				if (markersName === 'markersArraySTB') {
					markerObj.areaId = data.areaId
					markerObj.fn = this[fnName](data.count, 'rgb(221, 200, 34)', data.name)
				}

				// 指挥中心聚合
				if (markersName === 'markersArrayControl') {
					markerObj.areaId = data.areaId
					markerObj.fn = this[fnName](data.count, 'rgb(12, 232, 239)', data.name)
				}



				// 用户
				if (markersName === 'markersUser') {
					markerObj.name = data.name
					markerObj.address = data.address
					markerObj.userType = data.userType
					markerObj.center = [];
					markerObj.fn = this[fnName]('user')
				}
				// 事件
				if (markersName === 'markersEvent') {
					markerObj = data;
					markerObj.center = [];
					markerObj.fn = this[fnName]('rgb(255, 55, 56)')
				}
				// 摄像机
				if (markersName === 'markersCamera') {
					markerObj.fn = this[fnName](data.onlineType)
				}
				// 求助事件
				if (markersName === 'markersHelp') {
					markerObj = data;
					markerObj.center = [];
					markerObj.fn = this[fnName]('rgb(219, 121, 5)')
				}
				// 机顶盒
				if (markersName === 'markersSTB') {
					markerObj.name = data.name
					markerObj.address = data.address
					markerObj.terminalCode = data.terminalCode
					markerObj.fn = this[fnName]('STB')
				}
				// 指挥中心
				if (markersName === 'markersControl') {
					markerObj.name = data.name
					markerObj.address = data.address
					markerObj.terminalCode = data.terminalCode
					markerObj.fn = this[fnName]('control', data)
				}
				markerObj.markersName = markersName;
				this.addMarkers(markerObj)
			},
			// 添加markers
			addMarkers(markerObj) {
				let AMarker = new AMap.Marker({
					position: markerObj.position,
					content: markerObj.fn,
					offset: new AMap.Pixel(markerObj.center[0] || -15, markerObj.center[1] || -15)
				})
				AMarker.on('click', () => {
					let zoom = this.map.getZoom(); //获取当前地图级别

					if (markerObj.markersName === 'markersArrayCamera' || markerObj.markersName === 'markersArrayUser') {
						switch (zoom) {
							case 9:
							case 11:
							case 14:
								this.areaId = markerObj.areaId
								break
						}
					}

					if (markerObj.markersName === 'markersArrayEvent' ||
						markerObj.markersName === 'markersArrayUser' ||
						markerObj.markersName === 'markersArrayCamera' ||
						markerObj.markersName === 'markersArrayHelp' ||
						markerObj.markersName === 'markersArraySTB' ||
						markerObj.markersName === 'markersArrayControl') {
						this.map.setCenter(markerObj.position)
						this.moveOff()
						this.setZoomIn()
					}

					if (markerObj.markersName === 'markersCamera') {
						// this.getCameraDom(markerObj.aucCameraId)
						//调用查询摄像机的直播地址
						this.$http.post(GISApi.findLiveUrl, {
							cameraIds: [markerObj.id]
						}).then(res => {
							if (res.status == 200) {
								if (typeof window.QCefClient !== 'undefined') {
									for (let i = 0; i < res.result.length; i++) {
										res.result[i].storageUrl = GISApi.storageStatistics;
									}
									window.QCefClient.invokeMethod('QCef_Play_Rtsp', JSON.stringify({
										list: res.result
									}))
								}
							}
						})
					}
					if (markerObj.markersName === 'markersControl') {
						this.$http.get(GISApi.centerUser, {
							params: {
								areaId: markerObj.id
							}
						}).then(res => {
							if (res.status == 200) {
								this.showControlUserList = true;
								this.controlUserList = res.result.data;
								this.chosedControl = markerObj.name;
							}
						})
					}
				})
				AMarker.on('mouseover', () => {
					if (markerObj.markersName === 'markersEvent') {
						this.getEventInfo(markerObj, AMarker)
					}
					if (markerObj.markersName === 'markersHelp') {
						this.getHelpEventInfo(markerObj, AMarker)
					}
					if (markerObj.markersName === 'markersUser') {
						this.getUserInfo(markerObj, AMarker)
					}

					if (markerObj.markersName === 'markersSTB' || markerObj.markersName === 'markersAlarmColumn') {
						this.getJBInfo(markerObj, AMarker)
					}

					if (markerObj.markersName === 'markersCamera') {
						this.getCameraInfo(markerObj, AMarker)
					}
				})

				this.map.add(AMarker);
				this[markerObj.markersName].push(AMarker)
			},
			// 地图放大
			setZoomIn() {
				let zoom = this.map.getZoom(); //获取当前地图级别

				if (zoom < 9) {
					this.map.setZoom(9)
					return
				}

				if (zoom < 11) {
					this.map.setZoom(11)
					return
				}

				if (zoom < 13) {
					this.map.setZoom(13)
					return
				}

				if (zoom < 14) {
					this.map.setZoom(14)
					return
				}

				if (zoom >= 14) {
					this.map.setZoom(zoom + 1)
					return
				}
			},

			// markersDom（聚合）
			markersDom(count, bgColor, name) {
				let domDiv = document.createElement("div");
				domDiv.className = 'droplet'
				domDiv.style.backgroundColor = bgColor || 'rgba(253,82,0,0.8)'

				let domP = document.createElement("p");


				let domSpan = document.createElement("span");
				domSpan.style.width = '40px'
				domSpan.style.textAlign = 'center'
				domSpan.innerText = count

				if (name) {
					let domSpan1 = document.createElement("span");
					domSpan1.innerText = name
					domSpan1.style.fontSize = '12px'
					domSpan1.style.width = '40px'
					domSpan1.style.textAlign = 'center'
					domP.appendChild(domSpan1)
				}

				domP.appendChild(domSpan)
				domDiv.appendChild(domP)
				return domDiv
			},
			//markerDom指挥中心
			markerControlDom(markerType, data) {
				let className = 'iconfont iconyonghu';
				let ripple = document.createElement("div");
				ripple.style.width = '40px';
				ripple.style.height = '40px';
				ripple.style.borderRadius = '50%';
				ripple.style.display = 'flex';
				ripple.style.justifyContent = 'center';
				ripple.style.alignItems = 'center';
				ripple.style.background = 'rgb(12, 232, 239,.2)';
				let span = document.createElement('span');
				// span.className = className;
				span.style.fontSize = '12px';
				span.innerHTML = data.name;
				span.style.color = this.colors[0];
				// img.src =  imgSrc

				ripple.appendChild(span)
				return ripple
			},
			// markerDom(事件)求助或者报警
			markerEventDom(color) {
				let ripple = document.createElement("div");
				ripple.className = 'ripple-container'

				for (let i = 1; i < 5; i++) {
					let div = document.createElement("div")
					if (color) {
						div.style.backgroundColor = color
					}
					ripple.append(div)
				}
				return ripple
			},
			// markerDom(用户)
			markerUserDom(markerType) {
				let className = 'iconfont iconyonghu';
				let ripple = document.createElement("div");
				ripple.style.width = '40px';
				ripple.style.height = '40px';
				ripple.style.borderRadius = '50%';
				ripple.style.display = 'flex';
				ripple.style.justifyContent = 'center';
				ripple.style.alignItems = 'center';
				ripple.style.background = 'rgb(12, 232, 239,.2)';
				let span = document.createElement('span');
				span.className = className;
				span.style.fontSize = '20px';
				span.style.color = this.colors[0];
				// img.src =  imgSrc

				ripple.appendChild(span)
				return ripple
			},
			// markerDom(摄像机)
			markerCameraDom(markerType) {
				let className = 'iconfont iconqiakoushexiangtou';
				switch (markerType) {
					case '3':
						className = 'iconfont iconqiakoushexiangtou'
						break
					case '1':
						className = 'iconfont iconqiakoushexiangtou'
						break
					case '2':
						// imgSrc =  require('../../assets/GIS/marker-camera-gray.png')
						className = 'iconfont iconqiakoushexiangtou'
						break
				}

				let ripple = document.createElement("div");
				ripple.style.width = '40px';
				ripple.style.height = '40px';
				ripple.style.borderRadius = '50%';
				ripple.style.display = 'flex';
				ripple.style.justifyContent = 'center';
				ripple.style.alignItems = 'center';
				ripple.style.background = 'rgba(188, 80, 251,.2)';
				let span = document.createElement('span');
				span.className = className;
				span.style.fontSize = '20px';
				span.style.color = this.colors[1];
				// img.src =  imgSrc

				ripple.appendChild(span)
				return ripple
			},
			//机顶盒
			markerSTBDom(markerType) {
				let className;
				switch (markerType) {
					case 'Alarm':
						className = 'iconfont icondianqihuozaibaojingqi'
						break
					case 'STB':
						className = 'iconfont iconweiwangguanicon-defuben-'
						break
				}

				let ripple = document.createElement("div");
				ripple.style.width = '40px';
				ripple.style.height = '40px';
				ripple.style.borderRadius = '50%';
				ripple.style.display = 'flex';
				ripple.style.justifyContent = 'center';
				ripple.style.alignItems = 'center';
				ripple.style.background = 'rgb(221, 200, 34,.2)';
				let span = document.createElement('span');
				span.className = className;
				span.style.fontSize = '20px';
				span.style.color = this.colors[4];
				// img.src =  imgSrc

				ripple.appendChild(span)
				return ripple
			},
			// marker摄像机信息框
			createCameraTooltip(data) {
				let div = document.createElement('div')
				div.className = 'camera'
				div.innerHTML =
					`<ul>
                    <li><span>名称:</span><span>${data&&data.name?data.name:'-'}</span></li>
                     <li><span>播放时长:</span><span>${data&&data.playTime?data.playTime:'-'}</span></li>
                      <li><span>访问次数:</span><span>${data&&data.vv?data.vv:'-'}</span></li>
                       <li><span>事件处理人次数:</span><span>${data&&data.eventNum?data.eventNum:'-'}</span></li>
                    </ul>`
				return div
			},
			// 机顶盒信息框
			JBTooltip(data) {
				let div = document.createElement('div')
				div.className = 'camera stbInfo'
				div.innerHTML =
					`<ul>
			        <li><span>名称:</span><span>${data.name}</span></li>
			         <li><span>地点:</span><span>${data.address}</span></li>
			          <li><span>卡号:</span><span>${data.terminalCode}</span></li>

			        </ul>`
				return div
			},
			// 事件信息框
			eventTooltip(data) {
				let div = document.createElement('div')
				div.className = 'camera'
				div.innerHTML =
					`<ul>
				    <li><span>名称:</span><span>${data&&data.name?data.name:'-'}</span></li>
				    <li><span>报警中心:</span><span>${data&&data.centerName?data.centerName:'-'}</span></li>
				     <li><span>报警内容:</span><span>${data&&data.content?data.content:'-'}</span></li>
				      <li><span>报警地址:</span><span>${data&&data.address?data.address:'-'}</span></li>
				       <li><span>报警时间:</span><span>${data&&data.happenDate?data.happenDate:'-'}</span></li>
				    </ul>`
				return div
			},
			// 求助信息框
			helpTooltip(data) {
				let div = document.createElement('div')
				div.className = 'camera'
				div.innerHTML =
					`<ul>
				    <li><span>求助人:</span><span>${data&&data.realName?data.realName:'-'}</span></li>
				    <li><span>联系方式:</span><span>${data&&data.phone?data.phone:'-'}</span></li>
				    <li><span>求助内容:</span><span>${data&&data.content?data.content:'-'}</span></li>
				    <li><span>求助地址:</span><span>${data&&data.address?data.address:'-'}</span></li>
					<li><span>求助时间:</span><span>${data&&data.happenDate?data.createGmt:'-'}</span></li>
				    </ul>`
				return div
			},
			// 用户信息框
			userToolMtip(data) {
				let div = document.createElement('div')
				div.className = 'camera'
				div.innerHTML =
					`<ul>
					    <li><span>姓名:</span><span>${data&&data.name?data.name:'-'}</span></li>
					    <li><span>地址:</span><span>${data&&data.address?data.address:'-'}</span></li>
					    </ul>`
				return div
			},

			/*----------------------------------清除数据---------------------------*/
			// 地图清除 聚合事件
			clearMapPloy() {
				this.map.remove(this.markersArrayUser); // 用户聚合
				this.map.remove(this.markersArrayEvent); // 事件聚合
				this.map.remove(this.markersArrayCamera); // 摄像机聚合
				this.map.remove(this.markersArrayHelp); // 求助事件聚合
				this.map.remove(this.markersArraySTB); // 机顶盒聚合
				this.map.remove(this.markersArrayControl); // 指挥中心聚合

				this.map.remove(this.eventTooptip); // 事件信息框
				this.map.remove(this.cameraTooltip); //摄像机信息框
				this.map.remove(this.StbTooptip); //机顶盒信息框
				this.map.remove(this.HelpTooltip); //求助信息框
				this.map.remove(this.userTooptip); //用户信息框
				this.map.remove(this.controlTooptip); //指挥中心信息框

			},

			// 清除聚合数据
			clearPloyData() {
				this.markersArrayUser = []; // 用户maker（聚合）
				this.markerUserDataArray = []; // 用户数据（聚合）

				this.markerCameraDataArray = []; // 摄像机数据（聚合）
				this.markerHelpDataArray = []; // 求助数据（聚合）
				this.markerSTBDataArray = []; // 机顶盒数据（聚合）
				this.markerEventDataArray = []; // 事件数据（聚合）
				this.markerControlDataArray = []; // 指挥中心数据（聚合）

				this.markersArrayEvent = []; // 事件maker(聚合)
				this.markersArrayHelp = []; // 求助maker(聚合)
				this.markersArrayCamera = []; // 摄像机maker（聚合）
				this.markersArraySTB = []; // 机顶盒marker（聚合）
				this.markersArrayControl = []; // 指挥中心marker（聚合）
			},
			// 地图清除 marker
			clearMapMaker() {
				this.map.remove(this.markersSTB); // 机顶盒
				this.map.remove(this.markersUser); // 用户
				this.map.remove(this.markersCamera); // 摄像机
			},
			// 清除marker相关数据
			clearMarkerData() {
				this.HelpData = [] // 求助
				this.markersHelp = [] // 求助marker
				this.markerHelpArrayPosition = [] // 求助经纬度

				this.STBData = [] // 机顶盒数据
				this.markerSTBArrayPosition = [] //  机顶盒坐标maker集合
				this.markersSTB = [] // 机顶盒maker

				this.userData = [] // 用户
				this.markersUser = [] // 用户marker
				this.markerUserArrayPosition = [] // 用户经纬度

				this.cameraData = [] // 摄像头
				this.markersCamera = [] // 摄像头marker
				this.markerCameraArrayPosition = [] // 摄像头经纬度
			},
			// 报警和指挥中心
			claearOther() {
				this.map.remove(this.markersControl); // 指挥中心
				this.map.remove(this.markersEvent); // 事件
				this.map.remove(this.markersHelp); // 求助

				this.EventtData = [] // 事件
				this.markersEvent = [] // 事件marker
				this.markerEventArrayPosition = [] // 事件经纬度

				this.controlData = [] // 指挥中心
				this.markersControl = [] // 指挥中心marker
				this.markerControlArrayPosition = [] // 指挥中心经纬度

				this.HelpData = [] // 求助
				this.markersHelp = [] // 求助marker
				this.markerHelpArrayPosition = [] // 求助经纬度
			},
			/*-------------------------------其他-----------------------------------*/

			// 获取统计
			getStatistics() {
				this.$http.get(GISApi.boxStatistical, {
					params: {
						areaId: this.areaId
					}
				}).then(res => {
					if (res.status === 200) {
						this.STBStatistics = res.result.STB
						this.ALARMStatistics = res.result.ALARM
						this.cameraStatistics = res.result.CAMERA
					}
				});
			},

			// 显隐marker
			showMarker(switchName) {
				this[switchName] = !this[switchName];
				let array = [{
						name: 'peopleMarkerShow',
						status: this.peopleMarkerShow
					},
					{
						name: 'cameraMarkerShow',
						status: this.cameraMarkerShow
					},
					{
						name: 'helpAlarmMarkerShow',
						status: this.helpAlarmMarkerShow
					},
					{
						name: 'alarmMarkerShow',
						status: this.alarmMarkerShow
					},
					{
						name: 'STBMarkerShow',
						status: this.STBMarkerShow
					},
					{
						name: 'controlMarkerShow',
						status: this.controlMarkerShow
					},
				];
				let arr1 = array.filter((value) => value.status == true)
				if (arr1.length > 3) {
					let currentName = '';
					switchName === arr1[0].name ? currentName = arr1[1].name : currentName = arr1[0].name;
					switch (currentName) {
						case 'peopleMarkerShow':
							this.peopleMarkerShow = false;
							this.map.remove(this.markersArrayUser);
							this.map.remove(this.markersUser);
							break;
						case 'cameraMarkerShow':
							this.cameraMarkerShow = false;
							this.cameraDataList = [];
							this.map.remove(this.markersArrayCamera);
							this.map.remove(this.markersCamera);
							break
						case 'alarmMarkerShow':
							this.alarmMarkerShow = false;
							this.map.remove(this.markersArrayEvent);
							this.map.remove(this.markersEvent);
							break
						case 'helpAlarmMarkerShow':
							this.helpAlarmMarkerShow = false;
							this.map.remove(this.markersArrayHelp);
							this.map.remove(this.markersHelp);
							break
						case 'STBMarkerShow':
							this.STBMarkerShow = false;
							this.map.remove(this.markersSTB);
							this.map.remove(this.markersArraySTB);
							break
						case 'controlMarkerShow':
							this.controlMarkerShow = false;
							this.showControlUserList = false;
							this.map.remove(this.markersControl);
							this.map.remove(this.markersArrayControl);
							break
					}
				}
				if (this[switchName]) {
					if (this.pic < 8) {
						if (this[switchName]) {
							switch (switchName) {
								case 'peopleMarkerShow':
									this.getUserDataEvent(); // 人员聚合
									break;
								case 'cameraMarkerShow':
									this.getCameraData(); // 摄像机聚合
									break
								case 'alarmMarkerShow':
									this.getEventData(); // 事件聚合
									break
								case 'helpAlarmMarkerShow':
									this.helpEventList(); // 求助聚合
									break
								case 'STBMarkerShow':
									this.getSTBData(); // 机顶盒聚合
									break
								case 'controlMarkerShow':
									this.getControlData(); // 指挥中心聚合
									break
							}
						}
					} else {
						if (this[switchName]) {
							switch (switchName) {
								case 'peopleMarkerShow':
									this.getUserDataEvent() // 人员
									break;
								case 'cameraMarkerShow':
									this.getCameraData() // 摄像机聚合
									break
								case 'alarmMarkerShow':
									this.getEventData(); // 获取事件聚合
									break
								case 'helpAlarmMarkerShow':
									this.helpEventList() // 求助聚合
									break
								case 'STBMarkerShow':
									this.getSTBData(); // 获取机顶盒聚合
									break
								case 'controlMarkerShow':
									this.getControlData(); // 指挥中心聚合
									break
							}
						}
					}
				} else {
					switch (switchName) {
						case 'peopleMarkerShow':
							this.map.remove(this.markersArrayUser);
							this.map.remove(this.markersUser);
							break;
						case 'cameraMarkerShow':
							this.map.remove(this.markersArrayCamera);
							this.map.remove(this.markersCamera);
							break
						case 'alarmMarkerShow':
							this.map.remove(this.markersArrayEvent);
							this.map.remove(this.markersEvent);
							break
						case 'helpAlarmMarkerShow':
							this.map.remove(this.markersArrayHelp);
							this.map.remove(this.markersHelp);
							break
						case 'STBMarkerShow':
							this.map.remove(this.markersSTB);
							this.map.remove(this.markersArraySTB);
							break
						case 'controlMarkerShow':
							this.showControlUserList = false;
							this.map.remove(this.markersControl);
							this.map.remove(this.markersArrayControl);
							break
					}
				}
			},

			// 获取当前年月
			getDate() {
				let date = new Date()
				let month = date.getMonth()
				let fullYear = date.getFullYear()

				if (month + 1 < 10) {
					this.date = fullYear + '-0' + (month + 1)
				} else {
					this.date = fullYear + '-' + (month + 1)
				}

				if (date.getDate() < 10) {
					this.date = this.date + '-0' + date.getDate()
				} else {
					this.date = this.date + '-' + date.getDate()
				}

			},
			//发起视频对讲
			vision(userId) {
				this.$http.get(publicAPI.createChat, {
					params: {
						userId: userId
					}
				}).then(res => {
					if (res.status == 200) {
						this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${res.result}`).then(res1 => {
							if (res1.status === 200) {
								if (window.QCefClient) {
									res1.result.type = 3
									// res1.result.userId = sessionStorage.getItem('userId')
									window.QCefClient.invokeMethod('QCef_Open_Player', 3, false, JSON.stringify(res1.result))
								}
							}
						})
					}
				})
			},
			/*开始框选摄像机*/
			choosedCamera() {
				const $this = this;
				$this.isChoosedStatus = !$this.isChoosedStatus;
				if ($this.isChoosedStatus) {
					$this.mouseTool.rectangle({
						strokeColor: 'red',
						strokeOpacity: 0.5,
						strokeWeight: 6,
						fillColor: 'blue',
						fillOpacity: 0.5,
						strokeStyle: 'solid',
					}); //用鼠标工具画矩形
					$this.mouseToolListener = AMap.event.addListener($this.mouseTool, 'draw', function(e) { //添加事件
						if ($this.choosedTool) {
							$this.map.remove($this.choosedTool);
						}
						$this.choosedTool = e.obj;
						$this.getRectCameraInfo()
					});
				} else {
					$this.mouseTool.close();
					AMap.event.removeListener($this.mouseToolListener);
					if ($this.choosedTool) {
						$this.map.remove($this.choosedTool);
					}
				}
			},
			/*框选的摄像机信息*/
			getRectCameraInfo() {
				const $this = this;
				let data = [];
				$this.cameraDataList.forEach(item => {
					if ($this.choosedTool.contains([item.longitude, item.latitude])) {
						data.push(JSON.stringify(item))
					}
				})
				data = [...new Set(data)] // 数据去重
				let showChoosedCameraList = [];
				data.map(item => {
					showChoosedCameraList.push(JSON.parse(item));
				})
				if (data.length != 0) {
					let newData = [];
					if (data.length > 16) {
						newData = showChoosedCameraList.splice(0, 16);
					} else {
						newData = showChoosedCameraList;
					}
					let ids = newData.map(item => {
						return item.id;
					})
					this.$http.post(GISApi.findLiveUrl, {
						cameraIds: ids
					}).then(res => {
						if (res.status == 200) {
							if (typeof window.QCefClient !== 'undefined') {
								for (let i = 0; i < res.result.length; i++) {
									res.result[i].storageUrl = GISApi.storageStatistics;
								}
								window.QCefClient.invokeMethod('QCef_Play_Rtsp', JSON.stringify({
									list: res.result
								}))
							}
						}
					})
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.GIS {
		width: 100vw;
		height: 100vh;

		.iconfont {
			font-size: 50px;
			color: #06bfff;
		}
	}
</style>
<style lang="less">
	@import './timeGis.less';

	.GIS {
		.ripple-container {
			div {
				position: absolute;
				width: 10px;
				height: 10px;
				background-color: #ff4726;
				border-radius: 50%;
				left: 50px;
				top: 50px;
				transform: translate(-50%, -50%);
				animation: scaleRipple 1.5s infinite;

				&:nth-child(2) {
					width: 20px;
					height: 20px;
					opacity: 0.6;
					animation-delay: 0.12s;
				}

				&:nth-child(3) {
					width: 30px;
					height: 30px;
					opacity: 0.4;
					animation-delay: 0.24s;
				}

				&:nth-child(4) {
					width: 40px;
					height: 40px;
					opacity: 0.222;
					animation-delay: 0.44s;
				}

				&:nth-child(5) {
					width: 50px;
					height: 50px;
					opacity: 0.1666;
					animation-delay: 0.64s;
				}
			}

			@keyframes scaleRipple {
				0% {

					transform: translate(-50%, -50%) scale(1);
				}

				50% {
					transform: translate(-50%, -50%) scale(1.3);
				}

				100% {
					transform: translate(-50%, -50%) scale(1);
				}
			}
		}

		.tooltip {
			width: 450px;
			min-height: 300px;
			position: absolute;
			opacity: 1;
			background: #0f4771cc;
			color: #ccc;
			pointer-events: none;
			transition: all 0.25s ease-out;
			box-shadow: 2px 2px 10px 10px rgba(22, 173, 183, 0.27);
			z-index: 100;
			border: 1px solid #319d9f;

			&::after {
				border-left: solid transparent 10px;
				border-right: solid transparent 10px;
				border-top: solid #1496bb 10px;
				bottom: -10px;
				content: " ";
				height: 0;
				left: 50%;
				margin-left: -13px;
				position: absolute;
				width: 0;
			}

			&.user {
				width: 300px;
				height: 50px;
				overflow: hidden;

				div {
					display: block;
					justify-content: space-between;
				}
			}

			h2 {
				padding: 20px;
				border-bottom: 1px solid #0ce5ff;
			}

			.close {
				cursor: pointer;
				display: block;
				width: 20px;
				height: 20px;
				position: absolute;
				z-index: 999;
				right: 10px;
				top: 10px;
				// background: url("../../assets/close.png") no-repeat center center;
				background-size: 100% 100%;
			}

			>div {
				display: flex;
				text-align: left;
				align-items: center;
				margin: 10px;

				>span {
					width: 280px;
					margin-left: 20px;
				}

				>label {
					text-align-last: justify;
					text-justify: distribute-all-lines;
					display: inline-block;
					width: 100px;
				}
			}



		}

		.camera {
			// width: 300px;
			// height: 160px;
			background-color: rgba(57, 76, 138, 0.9);
			color: #fff;
			// box-shadow: 0 0 11px 0px #bcddec;
			border-radius: 5px;
			background: url(../../assets/GIS/alert.png);
			background-size: 100% 100%;
			background-repeat: no-repeat;
			padding: 20px;
			box-sizing: border-box;

			ul {
				height: 100%;
				display: flex;
				flex-direction: column;

			}

			li {
				flex-grow: 1;
				display: flex;
				align-items: center;

				span:nth-child(1) {
					display: inline-block;
					text-align: left;
					margin-right: 10px;
				}

				span:nth-child(2) {
					display: inline-block;
					// width: 120px;
					// text-align: left;
					color: #0ce5ff;
					flex: 1;
				}
			}

		}

		.stbInfo {
			width: 350px;

			li {
				span:nth-child(1) {
					flex: none;
				}

				span:nth-child(2) {
					width: auto;
				}
			}
		}

		.droplet {
			width: 50px;
			height: 50px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			transform: rotate(45deg);
			border-radius: 25px 25px 0 25px;
			background-color: #07C;

			p {
				transform: rotate(-45deg);
				display: block;
				color: #fff;

				span {
					display: block;
				}
			}
		}

		.button-box {
			width: 195px;
			border-radius: 5px;
			position: absolute;
			top: 35px;
			left: 50px;
			z-index: 10;
			overflow: hidden;
			// background-color: rgba(57, 76, 138, 0.9);
			background: url(../../assets/GIS/type.png);
			background-size: 100% 100%;
			background-repeat: no-repeat;

			.el-collapse {
				border: none
			}

			.el-collapse-item__header {
				background-color: transparent;
				color: #ffffff;
				border-left: 2px solid #0ce8ef;
				padding: 0 5px;
				margin: 20px;
				height: 25px;
				background: linear-gradient(45deg, rgba(12, 232, 239, .5), transparent);
				border-bottom: 0;
			}

			.el-collapse-item__content,
			.el-collapse-item__wrap {
				box-sizing: border-box;
				background-color: transparent;
				border: none;
			}

			.el-collapse-item__content {
				padding: 0 20px;
			}

			.el-switch.is-checked .el-switch__core {
				border-color: #d5d9e6;
				background-color: #d5d9e6;

				&:after {
					background-color: red;

				}

			}

			.el-switch__core:after {
				background-color: #757f8a;
			}

			.item-collapse {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 15px;
				color: #ffffff;
				font-size: 14px;

				p {
					display: flex;
					align-items: center;
				}

				i {
					margin-right: 10px;
					font-size: 18px;
				}

				.active-switch {
					background: url(../../assets/GIS/switch_active.png);
					background-size: 100% 100%;
					width: 30px;
					height: 10px;
					cursor: pointer;
				}

				.switch {
					background: url(../../assets/GIS/switch.png);
					background-size: 100% 100%;
					width: 30px;
					height: 10px;
					cursor: pointer;
				}

				&:last-child {
					padding-bottom: 30px;
				}
			}
		}

		.right-box {
			display: flex;
			flex-direction: column;
			right: 20px;
			left: auto;
			position: absolute;

			>div {
				&:first-child {
					margin-top: 0;
				}

				margin-top: 10px;
			}

			.total-box {
				width: 250px;
				padding: 10px 0px;
				box-sizing: border-box;
				position: absolute;
				line-height: 28px;
				top: 35px;
				left: 260px;
				z-index: 10;
				overflow: hidden;
				color: #ffffff;
				display: flex;
				align-items: center;
				background: url(../../assets/GIS/alert_small.png);
				background-size: 100% 100%;
				background-repeat: no-repeat;
				display: flex;
				align-items: center;
				flex-direction: column;
				color: #fff;

				span {
					font-size: 20px;

					&:nth-child(1) {
						font-size: 16px !important;
						color: rgba(255, 255, 255, .6);
					}
				}
			}
		}

		.search-box {
			width: 320px;
			padding: 10px 0px;
			box-sizing: border-box;
			height: 48px;
			position: absolute;
			line-height: 28px;
			top: 35px;
			left: 260px;
			z-index: 10;
			overflow: hidden;
			background: linear-gradient(to right, rgba(37, 216, 227, .4), rgba(37, 216, 227, 0));
			color: #ffffff;
			border-left: 4px solid rgb(37 216 227);
			display: flex;
			align-items: center;

			input {
				height: 100%;
				padding-left: 10px;
				border-radius: 20px;
				border: 1px solid transparent;
				background-color: transparent;
				color: #ffffff;
				opacity: .5;
				outline: none;
				margin-right: 10px;

				&::placeholder {
					color: #e6e6e6;
				}
			}

			span {
				cursor: pointer;
				background: url('../../assets/GIS/search.png');
				height: 48px;
				width: 200px;
				display: block;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.camera-btn-box {
			position: absolute;
			top: 90px;
			left: 610px;
			z-index: 10;
			height: 48px;

			button {
				height: 100%;
			}

			.camera-btn {
				background: transparent;
				color: #999;
				border: 1px solid #ccc;
			}

			.camera-btn-active {
				background: #266fff;
				color: #fff;
			}
		}
	}
</style>
